import React, { Component, Fragment } from 'react';

import proj from '../main-page-project/MainPageProject.css'
import styles from './MainPagePersonalization.css'
import fonts from '../../../styles/fonts.css'

// Airflow-style pipeline mock: infra work has no product screenshot, so the
// media panel is a terminal sub-panel like the recs strip on the etsy card.
const DAGS = [
    { name: 'ranking_train_daily',  mark: '✓', state: 'success', time: '14m',   kind: 'ok' },
    { name: 'embeddings_refresh',   mark: '●', state: 'running', time: '02:31', kind: 'run' },
    { name: 'feature_store_sync',   mark: '✓', state: 'success', time: '8m',    kind: 'ok' },
    { name: 'offline_eval_nightly', mark: '⧗', state: 'queued',  time: '--',    kind: 'wait' },
];

class MainPagePersonalization extends Component {
    render() {
        return (
            <Fragment>
                <div className={proj.project}>
                    <div className={[fonts["title-bold"], proj["project-title"]].join(' ')}>
                        <span className={proj.prompt}>&gt;</span>
                        <span>amazon personalization</span>
                    </div>
                    <div className={[proj["project-body"], proj["dir-media-left"]].join(' ')}>
                        <div className={proj["project-text"]}>
                            <div className={proj.paragraph}>
                                Sr. software engineer on Amazon Personalization - the team
                                behind product recommendations across Amazon. MLOps at
                                scale: migrated 100+ ML and data pipelines to Apache
                                Airflow, introduced a feature store and automated model
                                evaluation, and cut model training time by 20% to keep
                                recommendations fresh on real-time trends.
                            </div>
                            <div className={proj['appstores']}>
                                <a className={[fonts["title"], proj['appstore']].join(' ')}
                                   href="https://www.amazon.com" target="_blank" rel="noopener noreferrer">
                                    <svg className={proj["appstore-icon"]} aria-hidden="true" role="img"
                                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" strokeWidth="2"
                                         strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <line x1="2" y1="12" x2="22" y2="12"></line>
                                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                                    </svg>
                                    amazon.com
                                </a>
                            </div>
                        </div>
                        <div className={proj["project-media"]}>
                            <div className={styles["dags-panel"]}>
                                <div className={[fonts["title"], styles["dags-header"]].join(' ')}>
                                    $ airflow dags list
                                </div>
                                <div className={styles["dags-list"]}>
                                    {DAGS.map(function (d, i) {
                                        return (
                                            <div className={styles["dag-row"]} key={i}>
                                                <span className={[fonts["title"], styles["dag-name"]].join(' ')}>{d.name}</span>
                                                <span className={[fonts["title"], styles["dag-state"], styles["dag-" + d.kind]].join(' ')}>
                                                    {d.mark} {d.state}
                                                </span>
                                                <span className={[fonts["title"], styles["dag-time"]].join(' ')}>{d.time}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default MainPagePersonalization;
